import { Box, Paper, styled } from '@mui/material';

export const ChildContainerStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isProofPreviewPage',
})(({ theme, isProofPreviewPage }) => ({
  display: 'flex',
  flexDirection: isProofPreviewPage ? 'column' : 'row',
  justifyContent: 'center',
  marginBottom: 0,
  marginTop: !isProofPreviewPage && 10,

  [theme.breakpoints.down('lg')]: {
    marginBottom: !isProofPreviewPage && 127,
  },
}));

export const PaperStyled = styled(Paper)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: theme.zIndex.modal + 1,
  boxShadow: 'none',
}));
